export default __webpack_public_path__ + "static/layer5-image-hub-on-hashicorp-consul-e8f31c399d5d55bb85c18103a69ad9e3.webp";